<template>
    <rkm-form
        ref="RkmForm"
    >
        <rkm-row>
            <rkm-col>
                <rkm-form-checkbox
                    inline
                    v-model="model.urgente"
                >
                    Urgente
                </rkm-form-checkbox>
            </rkm-col>
        </rkm-row>

        <rkm-row>
            <rkm-col>
                <rkm-form-select
                    :options="data.form.unidades"
                    :validations="validations.unidadeId"
                    label="Unidade"
                    show-default-option
                    text-field="nomeFantasia"
                    v-model="model.unidadeId"
                    value-field="id"
                />
            </rkm-col>

            <rkm-col>
                <rkm-form-select
                    :options="infraestruturas"
                    :validations="validations.infraestruturaId"
                    label="Local de atendimento"
                    show-default-option
                    text-field="nome"
                    v-model="model.infraestruturaId"
                    value-field="id"
                />
            </rkm-col>
        </rkm-row>

        <rkm-row>
            <rkm-col>
                <rkm-form-textarea
                    :validations="validations.motivo"
                    label="Motivo do encaminhamento"
                    v-model="model.motivo"
                />
            </rkm-col>
        </rkm-row>

        <rkm-row>
            <rkm-col>
                <rkm-form-textarea
                    :validations="validations.observacoes"
                    label="Observações"
                    v-model="model.observacoes"
                />
            </rkm-col>
        </rkm-row>
    </rkm-form>
</template>

<script>
// Mixins.
import { repository } from '@/mixins'

export default {
    computed: {
        validations() {
            return {
                unidadeId: { required: true },
                infraestruturaId: { required: true },
                motivo: { required: true, min: 1, max: 300 },
                observacoes: { min: 1, max: 300 },
            }
        },
        infraestruturas() {
            let infraestruturas = []

            if (this.model.unidadeId) {
                const unidade = this.data.form.unidades.find(unidade => unidade.id === this.model.unidadeId)
                infraestruturas = unidade.infraestruturas
            }

            return infraestruturas
        },
    },
    methods: {
        save() {
            this.$refs.RkmForm.validate().then(response => {
                if (response === true) {
                    const duplicado = this.data.model.encaminhamentos.find(item => {
                        if (item.id !== this.model.id) {
                            return item.infraestruturaId === this.model.infraestruturaId
                        }

                        return false
                    })

                    if (duplicado) {
                        this.createNotification({
                            type: 'alert',
                            color: 'danger',
                            title: 'Ação não permitida',
                            message: 'Encaminhamento já incluído para esse local de atendimento!'
                        })
                    } else {
                        const unidade = this.data.form.unidades.find(unidade => unidade.id === this.model.unidadeId)
                        const infraestrutura = unidade.infraestruturas.find(infraestrutura => infraestrutura.id === this.model.infraestruturaId)

                        this.model.unidadeNomeFantasia = unidade.nomeFantasia
                        this.model.infraestruturaNome = infraestrutura.nome

                        if (this.model.id) {
                            const index = this.data.model.encaminhamentos.findIndex(item => item.id === this.model.id)
                            Object.assign(this.data.model.encaminhamentos[index], this.model)
                        } else {
                            this.model.id = this.uniqueId('pronto-atendimento-atendimento-medico-encaminhamento')
                            this.data.model.encaminhamentos.push(this.model)
                        }

                        this.$emit('saved', this.model)
                    }
                }
            })
        },
    },
    mixins: [repository],
    props: {
        data: { type: Object, required: true },
        model: { type: Object, required: true },
    },
    watch: {
        'model.unidadeId'() {
            this.model.infraestruturaId = null
        },
    },
}
</script>